import CrudBase from '../../../../CrudBase';
import axios from '../../../../../axios-common';

class ItensApi extends CrudBase {
  /**
   * Busca os detalhes do pedido pelo número do pedido.
   */
  getProductsGrid = (pedido) => axios.get(`${this.endpoint}/${pedido}/products-grid`);

  getByPedido = (pedido) => axios.get(`${this.endpoint}/${pedido}`);
  /**
   * Busca os detalhes por completo, listando todos os tamanhos e toda a grade do pedido pelo número do pedido.
   */
  getGradeByReferencia = (pedido) => axios.get(`${this.endpoint}/grade/${pedido}`);

  listPendentesColeta = (pedidoVenda, isSugerido) => axios.get(`${this.endpoint}/${pedidoVenda}/pendentes-coleta?isSugerido=${isSugerido}`);

  sumQuantidadePend = (pedidoVenda, isSugerido, isMix) => axios.get(`${this.endpoint}/${pedidoVenda}/soma-qtde-pendente?isSugerido=${isSugerido}&isMix=${isMix}`);

  defaultMethods = {
    ...this.defaultMethods,
    getByPedido: this.getByPedido,
    getGradeByReferencia: this.getGradeByReferencia,
    getProductsGrid: this.getProductsGrid,
    listPendentesColeta: this.listPendentesColeta,
    sumQuantidadePend: this.sumQuantidadePend,
  }
}

const itens = new ItensApi('api/comercial/pedidos/venda/itens');

export default itens.defaultMethods;
